module.exports = __webpack_public_path__ + "static/media/western-1.70e913c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/western-1.jpg
// module id = 116
// module chunks = 0